import React from 'react';
import { ChartBar, ToggleRight, ToggleLeft } from '@phosphor-icons/react';

export const ALL_PERMISSIONS = [
  { id: 'dashboard', label: 'Dashboard', description: 'View platform stats' },
  { id: 'categories', label: 'Categories', description: 'Manage categories & services' },
  { id: 'users', label: 'Users', description: 'View & manage users' },
  { id: 'listings', label: 'Listings', description: 'Approve/reject listings' },
  { id: 'bookings', label: 'Bookings', description: 'View & manage bookings' },
  { id: 'ads', label: 'Ads & Media', description: 'Manage ads & banners' },
  { id: 'subscriptions', label: 'Subscriptions', description: 'Manage plans, coupons & seller billing' },
];

export const StatCard = ({ title, value, sub, iconBg, icon: Icon, trend }) => (
  <div className="bg-[#161b26] rounded-2xl p-5 border border-[#252d3d]" data-testid={`stat-${title.toLowerCase().replace(/\s/g, '-')}`}>
    <div className="flex items-start justify-between mb-4">
      <div className={`w-10 h-10 ${iconBg} rounded-xl flex items-center justify-center`}><Icon size={20} className="text-white" weight="bold" /></div>
      <span className="text-emerald-400 text-xs flex items-center gap-0.5">
        <ChartBar size={12} /> {trend}
      </span>
    </div>
    <p className="text-3xl font-bold text-white mb-0.5">{value}</p>
    <p className="text-white/90 text-sm font-medium leading-tight">{title}</p>
    <p className="text-[#6b7a99] text-xs">{sub}</p>
  </div>
);

export const MiniStat = ({ title, value, iconBg, iconColor, icon: Icon }) => (
  <div className="bg-[#161b26] rounded-2xl p-4 border border-[#252d3d] flex items-center gap-3">
    <div className={`w-9 h-9 ${iconBg} rounded-xl flex items-center justify-center`}><Icon size={18} className={iconColor} weight="bold" /></div>
    <div><p className="text-xl font-bold text-white">{value}</p><p className="text-[#6b7a99] text-[11px]">{title}</p></div>
  </div>
);

export const DarkCard = ({ title, children, ...props }) => (
  <div className="bg-[#161b26] rounded-2xl border border-[#252d3d] p-5" {...props}>
    <h3 className="text-white font-semibold text-sm mb-4">{title}</h3>
    {children}
  </div>
);

export const StatusBadge = ({ status }) => {
  const colors = {
    live: 'bg-emerald-500/20 text-emerald-400', confirmed: 'bg-emerald-500/20 text-emerald-400',
    pending: 'bg-amber-500/20 text-amber-400', pending_payment: 'bg-amber-500/20 text-amber-400',
    pending_approval: 'bg-blue-500/20 text-blue-400', completed: 'bg-blue-500/20 text-blue-400',
    rejected: 'bg-red-500/20 text-red-400', cancelled: 'bg-red-500/20 text-red-400',
  };
  return <span className={`px-2 py-0.5 rounded-full text-[10px] font-semibold ${colors[status] || 'bg-[#252d3d] text-[#6b7a99]'}`}>{status}</span>;
};

export const LoadingSkeleton = () => (
  <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
    {[...Array(4)].map((_, i) => <div key={`skel-${i}`} className="bg-[#161b26] rounded-2xl p-6 animate-pulse border border-[#252d3d]"><div className="h-10 bg-[#252d3d] rounded-xl w-10 mb-4" /><div className="h-8 bg-[#252d3d] rounded w-3/4 mb-2" /><div className="h-4 bg-[#252d3d] rounded w-1/2" /></div>)}
  </div>
);

export const AdStatCard = ({ value, label, iconBg, iconColor, icon: Icon }) => (
  <div className="bg-[#161b26] rounded-xl p-4 border border-[#252d3d] flex items-center gap-3">
    <div className={`w-9 h-9 ${iconBg} rounded-lg flex items-center justify-center`}>
      <Icon size={18} className={iconColor} weight="bold" />
    </div>
    <div>
      <p className="text-2xl font-bold text-white">{value}</p>
      <p className="text-[#6b7a99] text-[11px]">{label}</p>
    </div>
  </div>
);

export const SettingsToggle = ({ label, description, checked, onChange, testId }) => (
  <div className="flex items-center justify-between py-3 border-b border-[#252d3d] last:border-0">
    <div>
      <p className="text-white text-sm font-medium">{label}</p>
      {description && <p className="text-[#6b7a99] text-xs mt-0.5">{description}</p>}
    </div>
    <button onClick={onChange} className="relative" data-testid={testId}>
      {checked ? (
        <ToggleRight size={36} className="text-emerald-400" weight="fill" />
      ) : (
        <ToggleLeft size={36} className="text-[#6b7a99]" weight="fill" />
      )}
    </button>
  </div>
);
